export const ru = {
  m: {
    createConference: "Создать конференцию",
    startConference: "Начать конференцию",
    conferenceLinkHint: "Ссылка на конференцию скопирована в буфер обмена.",
    mobileConferenceLinkHint: "Текущая адресная строка браузера является ссылкой на конференцию.",
    motivateHint: "Вы можете отправить её участникам, используя кнопку «Поделиться» в браузере.",
  },
  preferences: {
    title: "Настройки",
    enterYourName: "Введите ваше имя",
    errorNameMustBeNotEmpty: "Имя не может быть пустым",
    errorNameMustNotTooLongBegin: "Имя не может быть более",
    errorNameMustNotTooLongEnd: "символов",
    errorAllowOnlyLettersAndSpaces: "Допустимы только буквы, цифры и пробелы внутри имени",
    cameraLabel: "Камера",
    microphoneLabel: "Микрофон",
    noCameras: "Камеры не найдены",
    noMicrophones: "Микрофоны не найдены",
    defaultCameraName: "Камера {index}",
    defaultMicrophoneName: "Микрофон {index}",
    micTestButton: "Тест микрофона",
    micTestStopButton: "Остановить запись",
    micTestStopPlaybackButton: "Остановить воспроизведение",
    micTestSpeak: "Говорите, идет запись.",
    micTestPlayback: "Воспроизведение",
    micTestNoAudio: "Микрофон не найден",
    micTestNotSupported: "Тест микрофона не поддерживается в этом браузере",
    micTestProgressHint: "0 — {seconds} с"
  },
  access: {
    error: 'Нет доступа к камере/микрофону',
    request: 'Запросить доступ',
    suggest: 'Если клавиша запроса доступа не действует, проверьте, нет ли запрета в настройках браузера. После изменения настроек, рекомендуется перезапустить браузер и заново зайти на сайт.'
  }
}
